import React, { Component } from 'react'
import classNames from 'classnames'

class ModelSwitcher extends Component {
  state = { value: 'convertible' }

  updateValue = selection => {
    const { onChange } = this.props

    this.setState({ value: selection })
    onChange(selection)
  }

  render () {
    const { value } = this.state
    return (
      <div className={classNames('model-switcher')}>
        <ul className={'mode-switcher__list'}>
          <li className={classNames('mode-switcher__item', value === 'convertible' && 'mode-switcher__item--active')}
              onClick={() => this.updateValue('convertible')}
          >
            Convertible
          </li>
          <li className={classNames('mode-switcher__item', value === 'coupe' && 'mode-switcher__item--active')}
              onClick={() => this.updateValue('coupe')}>
            Coupé
          </li>
        </ul>
        <div className={classNames('mode-switcher__line', value === 'coupe' && 'mode-switcher__line--changed')}>
        </div>
      </div>
    )
  }
}

export default ModelSwitcher
